// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1kGFI","col":"CardReaderDesc_col__3Jrf0","label":"CardReaderDesc_label__2Pp28"};